<app-main-view> </app-main-view>
<!-- <div class="d-flex align-items-center justify-content-center h-100 w-100">
    <h1 class="text-center w-75">
        Bedankt voor je deelname aan de test periode van Park the Sun, deze is ondertussen afgelopen. Wij zijn hard
        aan de slag om de laatste verbeteringen door te voeren. Binnenkort komt de applicatie live te staan op
        www.parkthesun.com!
    </h1>
</div> -->